export default "__VITE_ASSET__BG7UGs6m__"